const initialState = {}

const appendedOrganizers = (organizers, data) => {
  return [data, ...organizers]
}

const updatedOrganizers = (organizers, data) => {
  const index = organizers.findIndex(organizer => organizer.id == data.id)
  if (index == -1) return organizers

  return [
    ...organizers.slice(0, index), 
    data,
    ...organizers.slice(index + 1, organizers.length)
  ]
}

const releasedOrganizers = (organizers, data) => {
  const index = organizers.findIndex(organizer => organizer.id == data.id)
  if (index == -1) return organizers

  return [
    ...organizers.slice(0, index), 
    ...organizers.slice(index + 1, organizers.length)
  ]
}

const appendedTerms = (terms, data) => {
  return [data, ...terms ]
}

const updatedTerms = (terms, data) => {
  const index = terms.findIndex(term => term.id == data.id)
  if (index == -1) return terms

  return [
    ...terms.slice(0, index), 
    data,
    ...terms.slice(index + 1, terms.length)
  ]
}

const releasedTerms = (terms, data) => {
  const index = terms.findIndex(term => term.id == data.id)
  if (index == -1) return terms

  return [
    ...terms.slice(0, index), 
    ...terms.slice(index + 1, terms.length)
  ]
}

const Partner = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'PARTNER.INIT':
      return {...state, ...payload}
    case 'PARTNER.CREATE_ORGANIZER':
      return {...state, organizers: appendedOrganizers(state.organizers, payload)}
    case 'PARTNER.UPDATE':
      return {...state, data: payload}
    case 'PARTNER.UPDATE_ORGANIZER':
      return {...state, organizers: updatedOrganizers(state.organizers, payload)}
    case 'PARTNER.DELETE_ORGANIZER':
      return {...state, organizers: releasedOrganizers(state.organizers, payload)}
    case 'PARTNER.CREATE_TERM':
      return {...state, terms: appendedTerms(state.terms, payload)}
    case 'PARTNER.UPDATE_TERM':
      return {...state, terms: updatedTerms(state.terms, payload)}
    case 'PARTNER.DELETE_TERM':
      return {...state, terms: releasedTerms(state.terms, payload)}
    default:
      return state
  }
}

export default Partner
